import React from 'react';
import PropTypes from 'prop-types';

import menuIcon from '@/shared/assets/images/menu_icon.svg';
import bellIcon from '@/shared/assets/images/bell_icon.svg';
import ApprovalNotificationDot from '@shared/components/atoms/ApprovalNotificationDot/indes';

import styles from './MobileHeader.module.scss';

/**
 * 모바일 전용 헤더 컴포넌트
 * - 좌측: 메뉴 아이콘 (햄버거)
 * - 중앙: 페이지 타이틀
 * - 우측: 알림 아이콘 (선택적)
 */
function MobileHeader({ title, onMenuClick, onNotificationClick, showNotification }) {
  return (
    <header className={styles.header}>
      <button
        type="button"
        className={styles.menuButton}
        onClick={onMenuClick}
        aria-label="메뉴 열기"
      >
        <img src={menuIcon} alt="메뉴" className={styles.icon} />
        <ApprovalNotificationDot />
      </button>

      <h1 className={styles.title}>{title}</h1>

      {showNotification ? (
        <button
          type="button"
          className={styles.notificationButton}
          onClick={onNotificationClick}
          aria-label="알림"
        >
          <img src={bellIcon} alt="알림" className={styles.icon} />
        </button>
      ) : (
        <div className={styles.placeholder} />
      )}
    </header>
  );
}

MobileHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onMenuClick: PropTypes.func.isRequired,
  onNotificationClick: PropTypes.func,
  showNotification: PropTypes.bool,
};

MobileHeader.defaultProps = {
  onNotificationClick: () => {},
  showNotification: false,
};

export default MobileHeader;
